import axios from 'axios';
import moment from "moment";
import Vue from 'vue';

import {parameters} from "../parameters";
import {USER_TOKEN, TOKEN_TYPE, EXPIRES_IN, USER_ROLE} from "./userConstants";


const httpClient = axios.create();

const authState = new Vue({
    data: {
        role: sessionStorage.getItem(USER_ROLE)
    }
});

let userRolePromise = null;

const authInterceptor = async (config) => {

    if (!isTokenValid()) {
        sessionStorage.setItem('poslog_url_backup', window.location.href);
        location.replace(`${parameters.fedUrl}/as/authorization.oauth2?client_id=${parameters.clientId}&response_type=code&redirect_uri=${parameters.redirectUri}&scope=openid%20profile%20email&code_challenge=`+ sessionStorage.getItem("hashedCodeChallenge") + `&code_challenge_method=S256`);
        return config;
    }

    if (sessionStorage.getItem(USER_ROLE) === null){
      if (!userRolePromise) {
            userRolePromise = callFedForUserRole().catch(error => {
                sessionStorage.setItem(USER_ROLE, "ROLE_USER");
                authState.role = "ROLE_USER";
                userRolePromise = null;
            });
        }

      await userRolePromise;
    }

    config.headers = {
          'Authorization': `Bearer ${sessionStorage.getItem(USER_TOKEN)}`,
          'x-api-key': parameters.xapikey
    };
    return config;
};

const isTokenValid = () => {
  return sessionStorage.getItem(USER_TOKEN) && sessionStorage.getItem(TOKEN_TYPE) && sessionStorage.getItem(EXPIRES_IN) &&
        moment().isBefore(moment(sessionStorage.getItem(EXPIRES_IN)))
};

const callFedForUserRole = async () => {
  let xmlHttpRequestUserRights = new XMLHttpRequest();

  xmlHttpRequestUserRights.open("POST", parameters.fedUrl + `/idp/userinfo.openid`);

  xmlHttpRequestUserRights.addEventListener("readystatechange", function() {
      const jsonTextUser = xmlHttpRequestUserRights.responseText
      const jsonTokenUser = JSON.parse(jsonTextUser)
      const roles = jsonTokenUser.role;
      sessionStorage.setItem(USER_ROLE, "ROLE_USER");
      authState.role = "ROLE_USER";
      for (const role of roles) {
        if (role.includes('id=ADMIN,id=POSDATA')){
          sessionStorage.setItem(USER_ROLE, "ROLE_ADMIN");
          authState.role = "ROLE_ADMIN";
          break
        }
      }
  })

  xmlHttpRequestUserRights.setRequestHeader("Authorization", "Bearer " + sessionStorage.getItem(USER_TOKEN))
  xmlHttpRequestUserRights.send();
};

httpClient.interceptors.request.use(authInterceptor);

httpClient.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

export { httpClient, isTokenValid, authState };



// WEBPACK FOOTER //
// ./src/requesters/httpClient.js